import {Grid, Link, useTheme} from "@mui/material";
import React from "react";
import {FormInput, FormInputDate} from "../../../domains/common/components/FormInput";
import {DealExpressParam, DealParamsMortgageAndExpress} from "../components/DealParams";
import {dealData} from "../deal";
import {waitInputComplete} from "../../../fn";
// Снятие обременения
export function RepaymentMortgageParamsContainer({onChange}) {
  const handleKuvdChange = waitInputComplete((e) => onChange({mortgageRegNumber: e.target.value}), 1500)

  const handleRegDate = (value) => {
    onChange({mortgageRegDate: value})
  }
  return (
    <Grid container>
      <Grid item xs={6}>
        <Grid container>
          <Grid item xs={12}>
            <FormInput label="Номер регистрации ипотеки"
                       name="mortgageRegNumber"
                       onChange={handleKuvdChange}
                       value={dealData?.deal?.mortgageRegNumber}
                       disabled={!!dealData?.deal?.mortgageRegNumber}/>
          </Grid>
          <Grid item xs={12} sx={{height: 12}}></Grid>
          <Grid item xs={12}>
            <FormInputDate label="Дата регистрационного дела"
                           name="mortgageRegDate"
                           onChange={handleRegDate}
                           value={dealData?.deal?.mortgageRegDate}
                           disabled={!!dealData?.deal?.mortgageRegDate}/>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={4}>
        <DealExpressParam dealData={dealData} onChange={onChange} />
      </Grid>
    </Grid>
  )
}